export const CONFIG_EXCESS_D2C = {
  spinner: false,
  step: 50,
  prefix: "£",
  precision: 0,
  max: 500,
  min: 50,
  default: 250,
  thousands: ",",
};
export const CONFIG_BUILDINGS_D2C = {
  spinner: false,
  step: 1000000,
  prefix: "£",
  precision: 0,
  max: 1000000,
  min: 1000000,
  default: 1000000,
  thousands: ",",
};
